import React from 'react'


function DealParties(props) {

}

export default DealParties